"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUsersQueryDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchUsersQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    search;
    userIds;
    email;
    username;
    roles; // Comma-separated list of roles to filter by
    referralCodes; // Devolvera los usuarios que tengan ese id de referral
    referredByUserIds; // Devolvera los usuarios que han sido referidos por el usuario
    stripe;
    platformUsage;
    isVerified;
    lastLoginDateFrom;
    lastLoginDateTo;
    createdAtFrom;
    createdAtTo;
}
exports.SearchUsersQueryDto = SearchUsersQueryDto;
